
// encryptionUtility.js
import CryptoJS from 'crypto-js';
import { env } from '../environment';

const SECRET_KEY = env.cryptoKey;

export const encrypted = {
  // Encrypt a text using AES
  encrypt(text) {
    const parsedBase64Key = CryptoJS.enc.Base64.parse(SECRET_KEY);
    const iv = CryptoJS.lib.WordArray.random(16);
    const encryptedData = CryptoJS.AES.encrypt(text, parsedBase64Key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    // Prepend the IV to the encrypted text
    const ivAndCipherText = iv.concat(encryptedData.ciphertext).toString(CryptoJS.enc.Base64);
    return ivAndCipherText;
  },

  // Decrypt a text using AES
  decrypt(text) {
    const parsedBase64Key = CryptoJS.enc.Base64.parse(SECRET_KEY);
    const decodedText = CryptoJS.enc.Base64.parse(text);
    const iv = CryptoJS.lib.WordArray.create(decodedText.words.slice(0, 4));
    const cipherText = CryptoJS.lib.WordArray.create(decodedText.words.slice(4));
    const decryptedData = CryptoJS.AES.decrypt(
      { ciphertext: cipherText },
      parsedBase64Key,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    const decryptedText = decryptedData.toString(CryptoJS.enc.Utf8);
    return decryptedText;
  },
};